import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";
export default class TextEditorService extends ApiService {
  namespace = "textEditor";
  icon = "WindowWithText";
  name = "textEditor";
  favicon = "T";
  window = 290;
  Width = 1100;
  DOMAIN = -31;
  action = "action";
  type = "type";
  deleteItems = [];
  singular = this.terminology.texteditor.singular;
  plural = this.terminology.texteditor.plural;
  vowel = this.terminology.texteditor.vowel;
  columns = [
    {
      header: this.t("displayName"),
      icon: "CubeBlue",
      field: "data",
    },
    {
      header: "Domain",
      icon: "Number",
      field: "domain",
      template: (data) => {
        return this.parseDomain(data["domain"]);
      },
    },
  ];

  listMenuItems = [
    {
      key: "edit",
      label: "Edit an Header/Footer",
      icon: "edit",
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Header",
      icon: PrimeIcons.LIST,
    },
  ];

  // filterItems = [
  //   {
  //     name: "Types",
  //     serviceId: "2",
  //     value: "2",
  //     realm: "2",
  //     selected: true,
  //     add: "create",
  //     edit: "listing",
  //   },
  //   {
  //     name: "Categories",
  //     serviceId: "3",
  //     value: "3",
  //     realm: "1",
  //     selected: false,
  //     add: "create",
  //     edit: "listing",
  //   },
  //   {
  //     name: "Folders",
  //     serviceId: "-2",
  //     value: "-2",
  //     realm: "0",
  //     selected: false,
  //     add: "create",
  //     edit: "listing",
  //   },
  // ];
  listingControls = [
    {
      key: "delete",
      label: "Delete",
      icon: "CircleWithX",
      action: (context, selectedItems) => {
        selectedItems.forEach((element) => {
          // Note: We have calculated all the rich-texts from directoris recursively.
          this.deleteItems.push({ id: element.id });
          context.$confirm.require({
            message:
              `Are you sure you want to delete the selected ` +
              selectedItems.length +
              ` File?`,
            dialogType: "confirm",
            accept: () => {
              this.deleteItems.forEach((item) => {
                this.delete(`/` + item.id).then((res) => {
                  context.emitter.emit("files-list", res);
                });
              });
            },
          });
        });
      },
    },
  ];
  permissions = [
    {
      key: "all",
      display_name: "All ",
      icon: "Bullets",
    },
    {
      key: "domain",
      display_name: "Invoices",
      icon: "Invoice",
      value: 35,
    },

    {
      key: "domain",
      display_name: "Sale Receipts",
      icon: "Invoice",
      value: 117,
    },
    {
      key: "domain",
      display_name: "Credit Memo",
      icon: "Invoice",
      value: 56,
    },
    {
      key: "domain",
      display_name: "Estimates",
      icon: "Calculator",
      value: 40,
    },
    {
      key: "domain",
      display_name: "Purchase Order",
      icon: "Invoice",
      value: 203,
    },
    {
      key: "domain",
      display_name: "Sales Order",
      icon: "Invoice",
      value: 206,
    },
  ];
  parseDomain(type) {
    let value = "";
    switch (type) {
      case 35:
        value = "Invoices";
        break;
      case DOMAIN.SALES_RECEIPTS:
        value = "Sale Receipts";
        break;
      case DOMAIN.CREDIT_MEMO:
        value = "Credit Memo";
        break;
      case DOMAIN.ESTIMATE:
        value = "Estimates";
        break;
      case DOMAIN.PURCHASE_ORDER:
        value = "Purchase Order";
        break;
      case 206:
        value = "Sales Order";
        break;

      default:
        value = "Others";
        break;
    }
    return value;
  }
  constructor() {
    super("rich-texts");
  }
}
